import React from "react";
import { Routes, Route } from "react-router-dom";
import { AppProvider } from "./context/AppContext";
import Navbar from "./components/layout/Navbar/Navbar";
import Footer from "./components/layout/Footer/Footer";
import SuccessModal from "./components/common/SuccessModal/SuccessModal";
import HomePage from "./pages/HomePage";
import ToeicPage from "./pages/ToeicPage";
import JlptPage from "./pages/JlptPage";
import "./styles/global.css";

function App() {
  return (
    <AppProvider>
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/toeic" element={<ToeicPage />} />
        <Route path="/jlpt" element={<JlptPage />} />
      </Routes>
      <Footer />
      <SuccessModal />
    </AppProvider>
  );
}

export default App;
